module.exports = __webpack_public_path__ + "images/marker-logo.c99641.png";